export default __webpack_public_path__ + "static/media/star_icon.6d6176ed.svg";